import * as React from "react";
//import { StaticImage } from "gatsby-plugin-image";

import ReactPlayer from "react-player";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import * as Styles from "./mainlayout.module.scss";

import logo from "../images/inTouch-animated.gif";
import rightimg from "../images/rightimg.png";

import pdficon from "../images/pdficon.png";
import emailicon from "../images/emailicon.png";
import calendaricon from "../images/calendaricon.png";
import comingsoonimg from "../images/comingSoon.png";
import whatplay from "../images/whatplay.png";
import howplay from "../images/howplay.png";
import listplay from "../images/listplay.png";
import notificationsplay from "../images/notificationsplay.png";
import searchplay from "../images/searchplay.png";
import shareplay from "../images/shareplay.png";
import analyticsplay from "../images/analyticsplay.png";
import tipsplay from "../images/tipsplay.png";
import footermock from "../images/footermock.png";

import whatVideo from "../videos/what-is-inTOUCH.mp4";

// data
const cards = [
  {
    id: "what",
    title: "WHAT IS inTOUCH?",
    img: whatplay,
    vidsrc: whatVideo,
    pdfurl:
      "https://assets.ulabs.info/assets/intouch-infopage/What-Is-inTOUCH.pdf",
    pdftitle: "What is inTOUCH ",
    color: "#E95800",
  },
  {
    id: "how",
    title: "HOW DO I INSTALL IT?",
    img: howplay,
    vidsrc:
      "https://cdn.biteable.com/social/renders/8090952/3664595/1560284/2c45a90b401f84e2b8ce86f56239110ca4219637.mp4",
    pdfurl:
      "https://assets.ulabs.info/assets/intouch-infopage/Installation.pdf",
    pdftitle: "Installation Instructions ",
    color: "#1099A8",
  },
  {
    id: "list",
    title: "LIST VIEW -VS- DIAGRAM VIEW",
    img: listplay,
    vidsrc: false,
    pdfurl:
      "https://assets.ulabs.info/assets/intouch-infopage/Navigating-your-App.pdf",
    pdftitle: "Navigating Your App ",
    color: "#BC027F",
  },
  {
    id: "notifications",
    title: "NOTIFICATIONS EVERYWHERE",
    img: notificationsplay,
    vidsrc:
      "https://cdn.biteable.com/social/renders/8090952/3663635/1560023/31d7a4f55eb815570f0ed94bdc12fcfe01b7aecc.mp4",
    pdfurl:
      "https://assets.ulabs.info/assets/intouch-infopage/Notifications.pdf",
    pdftitle: "Notifications ",
    color: "#0D96F2",
  },
  {
    id: "search",
    title: "THE BEAUTY OF SEARCH",
    img: searchplay,
    vidsrc: false,
    pdfurl: "https://assets.ulabs.info/assets/intouch-infopage/Search.pdf",
    pdftitle: "Search ",
    color: "#8EB814",
  },
  {
    id: "share",
    title: "HOW TO SHARE+",
    img: shareplay,
    vidsrc: false,
    pdfurl: "https://assets.ulabs.info/assets/intouch-infopage/Share%2B.pdf",
    pdftitle: "Share+ ",
    color: "#663399",
  },
  {
    id: "analytics",
    title: "ANALYTICS",
    img: analyticsplay,
    vidsrc: false,
    pdfurl: false,
    pdftitle: "PDF Coming Soon...",
    color: "#663399",
  },
  {
    id: "tips",
    title: "TIPS AND TRICKS",
    img: tipsplay,
    vidsrc: false,
    pdfurl:
      "https://assets.ulabs.info/assets/intouch-infopage/Tips-and-Tricks.pdf",
    pdftitle: "Tips and Tricks ",
    color: "#663399",
  },
];

const ModalComponent = (props) => {
  const { index, id, title, src, img } = props;

  const [modal, setModal] = React.useState(false);
  const [playing, setPlaying] = React.useState(false);
  const play = () => setPlaying(true);
  const pause = () => setPlaying(false);
  const toggle = () => setModal(!modal);

  return (
    <div>
      <button className={Styles.link} onClick={toggle}>
        <img src={img} alt={title} className={Styles.cardImg} />
      </button>
      <button
        className={Styles.link}
        onClick={toggle}
        role="link"
        tabIndex={index}
      >
        {title}
      </button>
      {(() => {
        if (!src) {
          return (
            <div className={Styles.comingSoon}>
              <img src={comingsoonimg} alt="coming soon" />
            </div>
          );
        }
      })()}
      {src && (
        <Modal
          isOpen={modal}
          toggle={toggle}
          unmountOnClose={false}
          onOpened={play}
          onClosed={pause}
          size="lg"
          key={id}
        >
          <ModalHeader toggle={toggle}>{title}</ModalHeader>
          <ModalBody>
            <ReactPlayer url={src} width="100%" controls playing={playing} />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggle}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </div>
  );
};
class MainLayout extends React.Component {
  render() {
    return (
      <div className={Styles.page}>
        <div className={Styles.mainContainerDiv}>
          <div className={Styles.headerDiv}>
            <div className={Styles.headerLeftDiv}>
              <img src={logo} alt="logo" className={Styles.logoImg} />
            </div>
            <div className={Styles.headerCenterDiv}>
              <h1>Welcome to United laboratories inTOUCH!</h1>
              <p>
                inTOUCH is an app skinned for United Laboratories Sales Reps.
                View and share all our product marketing and other helpful files
                such as brochures, videos, forms, price lists and more at the
                touch of a finger. This app is downloadable on any device and
                once set up, requires no wifi or maintenance. Below, please find
                help videos to get you started.
              </p>
            </div>
            <div className={Styles.headerRightDiv}>
              <img src={rightimg} alt="app preview screens" />
            </div>
          </div>
          <div className={Styles.cardscontainer}>
            {cards.map((card, i) => (
              <div key={card.title} className={Styles.card}>
                <ModalComponent
                  id={card.id}
                  title={card.title}
                  src={card.vidsrc}
                  img={card.img}
                  index={i}
                />
                {card.pdfurl && (
                  <a href={`${card.pdfurl}`} target="_blank" rel="noreferrer">
                    <img
                      src={pdficon}
                      alt="pdf"
                      style={{ maxWidth: "30px", padding: "5px" }}
                    />
                    <span aria-label="PDF Icon">{card.pdftitle}</span>
                  </a>
                )}
              </div>
            ))}
          </div>
          <h1 className={Styles.helpHeading}>STILL NEED HELP?</h1>
          <div className={Styles.helpLinks}>
            <a
              href="mailto:intouch@unitedlabsinc.com"
              target="_blank"
              rel="noreferrer"
            >
              <img src={emailicon} alt="email icon" />
              <span>eMail the helpdesk at:</span>
              <span
                style={{
                  color: "#7f0aca",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                inTOUCH@unitedlabsinc.com
              </span>
            </a>
            <div>or</div>
            <a
              href="https://calendly.com/intouchhelp/help-with-intouch"
              target="_blank"
              rel="noreferrer"
            >
              <img src={calendaricon} alt="calendar icon" />
              <span>Need to talk to someone?</span>
              <span
                style={{
                  color: "#7f0aca",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                SCHEDULE AN APPOINTMENT
              </span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default MainLayout;
